import axios from "axios";
import {
  STORE_CREATE_REQUEST,
  STORE_CREATE_SUCCESS,
  STORE_CREATE_FAIL,
  ALL_STORE_VIEW_REQUEST,
  ALL_STORE_VIEW_SUCCESS,
  ALL_STORE_VIEW_FAIL,
  STORE_BY_ID_SUCCESS,
  STORE_UPDATE_REQUEST,
  STORE_UPDATE_SUCCESS,
  STORE_UPDATE_FAIL,
  SERVERADDRESS,
} from "../constants";
// import { notifyFailure, notifySuccess } from "../components/toast";

export const createStore =
  (obj, callback, setReservationId) => async (dispatch) => {
    dispatch({
      type: STORE_CREATE_REQUEST,
    });
    try {
      const { data } = await axios.post(
        `${SERVERADDRESS}/v1/store/createStore`,
        obj
      );
      dispatch({
        type: STORE_CREATE_SUCCESS,
        payload: data,
      });
      callback && callback(data.id);
    } catch (err) {
      console.log(err);
      //   notifyFailure(err.response.data.message);
      dispatch({
        type: STORE_CREATE_FAIL,
        payload: err,
      });
    }
  };

export const getFilterStores = (obj, callback) => async (dispatch) => {
  dispatch({
    type: ALL_STORE_VIEW_REQUEST,
  });
  try {
    const { data } = await axios.post(
      `${SERVERADDRESS}/v1/store/getFilterStores`,
      obj
    );

    localStorage.setItem("store", JSON.stringify(data));
    dispatch({
      type: ALL_STORE_VIEW_SUCCESS,
      payload: data.slice(0, 200),
    });
    // callback && callback(data);
  } catch (err) {
    // console.log(err);
    dispatch({
      type: ALL_STORE_VIEW_FAIL,
      payload: err,
    });
  }
};

export const getAllStores = (obj, callback) => async (dispatch) => {
  dispatch({
    type: ALL_STORE_VIEW_REQUEST,
  });
  try {
    const { data } = await axios.get(
      `${SERVERADDRESS}/v1/store/getAllStores`,
      obj
    );

    localStorage.setItem("store", JSON.stringify(data));
    dispatch({
      type: ALL_STORE_VIEW_SUCCESS,
      payload: data.slice(0, 200),
    });
    // callback && callback(data);
  } catch (err) {
    // console.log(err);
    dispatch({
      type: ALL_STORE_VIEW_FAIL,
      payload: err,
    });
  }
};

export const setStoreData = (obj) => async (dispatch) => {
  dispatch({
    type: STORE_BY_ID_SUCCESS,
    payload: obj,
  });
};

export const updateStore = (obj, handleSuccess) => async (dispatch) => {
  dispatch({
    type: STORE_UPDATE_REQUEST,
  });
  try {
    const { data } = await axios.patch(
      `${SERVERADDRESS}/v1/store/updateStore`,
      obj
    );
    handleSuccess();
    // notifySuccess("Updated successfully !");
    dispatch({
      type: STORE_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (err) {
    // console.log(err);
    // notifyFailure(err?.response?.data?.message);
    dispatch({
      type: STORE_UPDATE_FAIL,
      payload: err,
    });
  }
};
